import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    EnterCarrierDataParamsT,
    EnterCostPriceParamsT,
    EnterCostToBePaidParamsT,
    FTLBidGetResponseT,
    FTLBidsGetListParamsT,
    FTLBidsGetListResponseT,
    ChangeStatusParamsT,
    EnterCommentParamsT,
    FTLBidsGetExcelParamsT,
    FtlGetListParams,
    FtlIntracityGetListResponse,
    EnterCarrierDataIntracityParams,
    FtlIntracityGetQuantityParams,
    FtlIntracityGetQuantityResponse,
    FtlGetListParamsCamel,
    FtlOrderSendRequestForPaymentPayload,
} from '../types/ftl_bids.types'
import {
    CompleteIntracityPayload,
    EnterDeliveredDataIntracityPayload,
    StatusToCompletedPayload,
} from '@/core/types/additional_services.types'
import { FTLOrderDownloadResponseT } from '@/core/types/couriers.types'

export class FTLBidsRepository {
    getList(params?: FTLBidsGetListParamsT): Promise<AxiosResponse<FTLBidsGetListResponseT>> {
        return http.get('/cabinet/api/v2/admin/ftl-bids', { params })
    }

    getFtlList(
        params?: FtlGetListParamsCamel
    ): Promise<AxiosResponse<FtlIntracityGetListResponse>> {
        return http.get('/cabinet/api/v2/admin/ftl-orders', { params })
    }

    getListIntracity(
        params?: FtlGetListParams
    ): Promise<AxiosResponse<FtlIntracityGetListResponse>> {
        return http.get('/cabinet/api/v2/admin/ftl-orders/intracity', { params })
    }

    getFTLBid(id: number): Promise<AxiosResponse<FTLBidGetResponseT>> {
        return http.get(`/cabinet/api/v2/ftl-bid/${id}`)
    }

    updateFTLBid(id: number, form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl-bid/${id}`, form_data)
    }

    enterCostPrice(params: EnterCostPriceParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-bid/cost-price/${params.id}`, params)
    }

    enterCostToBePaid(params: EnterCostToBePaidParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-bid/paid-price/${params.id}`, params)
    }

    enterComment(id: number, params: EnterCommentParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-bid/lack-data-comment/${id}`, params)
    }

    enterCarrierData(params: EnterCarrierDataParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-bid/carrier-data/${params.id}`, params)
    }

    enterCarrierDataIntracity(
        params: EnterCarrierDataIntracityParams
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/intracity/carrier-data/${params.id}`, params)
    }

    enterDeliveryData(id: number, params: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl/delivery/${id}`, params)
    }

    enterDeliveryDataIntracity(
        id: number,
        params: EnterDeliveredDataIntracityPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/intracity/delivery/${id}`, params)
    }

    enterCompletedData(
        id: number,
        payload?: StatusToCompletedPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl/complete/${id}`, payload)
    }

    completeIntracity(
        id: number,
        payload?: CompleteIntracityPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-order/intracity/complete/${id}`, payload)
    }

    changeStatus(params: ChangeStatusParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/v2/ftl-bid/status/${params.id}`, params)
    }

    changeStatusFTLOrder(id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl/status/${id}`, payload)
    }

    exportDeclaration(id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl/export-declaration/${id}`, payload)
    }

    crossBorder(id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/cabinet/api/v2/ftl/cross-the-border/${id}`, payload)
    }

    sendD24(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/bid/${id}/send-to-contract`, { id })
    }

    createFtl(ftl_bid_payload: FormData): Promise<AxiosResponse<void>> {
        return http.post('/cabinet/api/v2/ftl-order', ftl_bid_payload)
    }

    resendOneC(id: number): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/v2/ftl/orders/${id}/resend-one-c`, { id })
    }

    exportExcel(id: number): Promise<AxiosResponse<FTLOrderDownloadResponseT>> {
        return http.get('/cabinet/api/v2/ftl/transcript/export', {
            responseType: 'blob',
            params: { id },
        })
    }

    uploadCustomPaymentDocument(file: File): Promise<AxiosResponse<{ data: { path: string } }>> {
        const form_data = new FormData()
        form_data.append('type', '14')
        form_data.append('file', file)

        return http.postFormData('/cabinet/api/file/upload', form_data)
    }

    exportBids(params: FTLBidsGetExcelParamsT): Promise<AxiosResponse<Blob>> {
        return http.get('/cabinet/api/v2/ftl-bid/export', {
            responseType: 'blob',
            params,
        })
    }

    exportFtlIntracity(params: FtlGetListParams): Promise<AxiosResponse<Blob>> {
        return http.get('/cabinet/api/v2/admin/ftl-orders/intracity/export', {
            responseType: 'blob',
            params,
        })
    }

    exportAccountantFtlIntracity(params: FtlGetListParams): Promise<AxiosResponse<Blob>> {
        return http.get('/cabinet/api/v2/admin/ftl-orders/intracity/export-accountant', {
            responseType: 'blob',
            params,
        })
    }

    printFtlBidInvoices(bid_id: number): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/ftl-bid/${bid_id}`, { responseType: 'blob' })
    }

    printLogistBid(bid_id: number): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/logist-bid/${bid_id}`, { responseType: 'blob' })
    }

    printFtlBidWaypointInvoice(
        bid_id: number,
        waypoint_index: number
    ): Promise<AxiosResponse<any>> {
        return http.get(`/print/api/ftl-bid/${bid_id}/${waypoint_index}`, { responseType: 'blob' })
    }

    checkAvr(order_id: number): Promise<AxiosResponse<{ data: { isPosted: boolean } }>> {
        return http.get(`/cabinet/api/v2/ftl/check-avr/${order_id}`)
    }

    getQuantity(
        params?: FtlIntracityGetQuantityParams
    ): Promise<AxiosResponse<FtlIntracityGetQuantityResponse>> {
        return http.get('/cabinet/api/v2/admin/ftl-orders/intracity/quantity', { params })
    }

    sendRequestForPayment(id: number, payload: FtlOrderSendRequestForPaymentPayload): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/v2/admin/ftl-orders/${id}/payment`, payload)
    }
}
